import React from 'react';
import { NavLink, Link, Outlet } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';
import { Button } from '../ui/Button';

export const PublicLayout = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col font-sans">
      {/* Navigation */}
      <nav className="border-b border-slate-100 sticky top-0 bg-white/80 backdrop-blur-md z-50">
        <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <div className="w-9 h-9 rounded-xl bg-indigo-600 flex items-center justify-center text-white shadow-lg shadow-indigo-200">
              <SafeIcon name="Hexagon" className="text-xl" />
            </div>
            <span className="text-xl font-black text-slate-900 tracking-tighter uppercase">HMS-innsikt</span>
          </Link>

          <div className="hidden xl:flex items-center gap-8">
            <NavLink to="/" className={({ isActive }) => `text-[11px] font-black uppercase tracking-widest transition-colors ${isActive ? 'text-indigo-600' : 'text-slate-500 hover:text-indigo-600'}`}>Hjem</NavLink>
            <NavLink to="/tjenester" className="text-[11px] font-black uppercase tracking-widest text-slate-500 hover:text-indigo-600">Tjenester</NavLink>
            <NavLink to="/for-ledere" className="text-[11px] font-black uppercase tracking-widest text-slate-500 hover:text-indigo-600">For Ledere</NavLink>
            <NavLink to="/for-hr" className="text-[11px] font-black uppercase tracking-widest text-slate-500 hover:text-indigo-600">For HR</NavLink>
            <NavLink to="/for-konsulenter" className="text-[11px] font-black uppercase tracking-widest text-slate-500 hover:text-indigo-600">For Konsulenter</NavLink>
            <NavLink to="/kurs-info" className="text-[11px] font-black uppercase tracking-widest text-slate-500 hover:text-indigo-600">Kurs</NavLink>
            <NavLink to="/kontakt" className="text-[11px] font-black uppercase tracking-widest text-slate-500 hover:text-indigo-600">Kontakt</NavLink>
          </div>

          <div className="flex items-center gap-3">
            <Link to="/booking">
              <Button variant="secondary" size="sm" className="hidden sm:inline-flex text-[10px] font-black uppercase tracking-widest">Book samtale</Button>
            </Link>
            <Link to="/login">
              <Button variant="primary" size="sm" className="text-[10px] font-black uppercase tracking-widest shadow-lg shadow-indigo-100">Logg inn</Button>
            </Link>
          </div>
        </div>
      </nav>

      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="bg-slate-900 text-slate-400 py-20">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-4 gap-16">
          <div className="space-y-6">
            <div className="flex items-center gap-2.5 text-white">
              <SafeIcon name="Hexagon" className="text-2xl text-indigo-400" />
              <span className="text-xl font-black tracking-tighter uppercase">HMS-innsikt</span>
            </div>
            <p className="text-sm leading-relaxed font-medium">
              Norges ledende plattform for datadrevet psykososialt arbeidsmiljøarbeid. Vi kombinerer psykologisk ekspertise med moderne teknologi.
            </p>
          </div>
          <div>
            <h4 className="text-white font-black uppercase tracking-widest text-xs mb-8">Tjenester</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="#" className="hover:text-white transition-colors">Arbeidsmiljøanalyse</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Konflikthåndtering</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Lederstøtte</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Digitalt HMS-arbeid</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-black uppercase tracking-widest text-xs mb-8">Ressurser</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li><Link to="/kurs-info" className="hover:text-white transition-colors">Kurs &amp; Webinarer</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Fagartikler</Link></li>
              <li><Link to="#" className="hover:text-white transition-colors">Maler &amp; Sjekklister</Link></li>
              <li><Link to="/booking" className="hover:text-white transition-colors">Book en Demo</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-black uppercase tracking-widest text-xs mb-8">Hovedkontor</h4>
            <ul className="space-y-4 text-sm font-medium">
              <li className="flex items-center gap-3"><SafeIcon name="MapPin" size={16} /> Oslo, Norge</li>
              <li className="flex items-center gap-3"><SafeIcon name="Mail" size={16} /> post@hms-innsikt.no</li>
              <li className="flex items-center gap-3"><SafeIcon name="Phone" size={16} /> +47 22 33 44 55</li>
            </ul>
          </div>
        </div>
        <div className="max-w-7xl mx-auto px-6 mt-20 pt-8 border-t border-white/5 text-[10px] font-black uppercase tracking-widest flex justify-between items-center">
          <p>© 2024 HMS-innsikt AS. Alle rettigheter reservert.</p>
          <div className="flex gap-8">
            <Link to="#" className="hover:text-white">Personvern</Link>
            <Link to="#" className="hover:text-white">Vilkår</Link>
            <Link to="#" className="hover:text-white">Cookies</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};